module.exports = __webpack_public_path__ + "5699e566222b30658ee68673e6018aa0.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/illustrations/podcasters-spread-embed.png
// module id = LGAY
// module chunks = 15